import { render, staticRenderFns } from "./CustomFormDetailMobile.vue?vue&type=template&id=6400523e&"
import script from "./CustomFormDetailMobile.vue?vue&type=script&lang=js&"
export * from "./CustomFormDetailMobile.vue?vue&type=script&lang=js&"
import style0 from "./CustomFormDetailMobile.vue?vue&type=style&index=0&id=6400523e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports